export function isPrimitive<T extends any = any>(value: T): boolean {
    return value == null || typeof value !== 'object';
}

export function isNumber(value: any): boolean {
    return typeof value === 'number' && isFinite(value);
}
